import { Controller } from "@hotwired/stimulus";
import { fitThumbs } from "../help/shots";

// A phone shot pre-rendered by the help kit. The markup arrives from the server at
// its native size. This scales it to fit its figure and keeps it fitted on resize.
// Nothing about the screen is rendered in the browser.
export default class extends Controller {
  connect() {
    fitThumbs();
  }
}
